import React from "react";
import LoadingSpinner from "../../commonComponents/util/LoadingSpinner";
import FadeoutErrorMessage from "../../commonComponents/util/FadeOutErrorMessage";

export default class TagInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      addingError: false,
      deletingError: false,
      duplicateError: false,
      errorMessage: "",
      updatingError: false,

      newValue: "",
      tagForUpdate: null
    };
  }

  clearErrorMessages = () => {
    const {
      addingError,
      deletingError,
      duplicateError,
      errorMessage,
      updatingError
    } = this.state;
    if (
      addingError ||
      deletingError ||
      duplicateError ||
      errorMessage ||
      updatingError
    ) {
      this.setState({
        addingError: false,
        deletingError: false,
        duplicateError: false,
        errorMessage: "",
        updatingError: false
      });
    }
  };

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
    if (
      this.state.duplicateError &&
      this.props.values.map(v => v.value).indexOf(e.target.value) <= -1
    )
      this.setState({ duplicateError: false });
  }

  onUpdateTagClick = tag => {
    if (this.props.allowUpdate) {
      this.setState(
        {
          tagForUpdate: tag,
          updatingError: false
        },
        () => {
          if (this.editTagInput) {
            this.editTagInput.focus();
          }
        }
      );
    }
  };

  updateTag = async () => {
    const { tagForUpdate } = this.state;

    if (!tagForUpdate) return;

    const tagPriorToUpdate = this.props.values.find(
      t => t.key === this.state.tagForUpdate.key
    );
    if (tagPriorToUpdate && tagForUpdate.value === tagPriorToUpdate.value) {
      return;
    }

    this.clearErrorMessages();

    if (
      this.props.values
        .map(v => v.value.toLowerCase())
        .indexOf(tagForUpdate.value.toLowerCase()) > -1
    ) {
      this.setState({
        duplicateError: true
      });
      return;
    }

    await this.props.update(tagForUpdate);

    if (this.props.updating.success) {
      this.setState({ tagForUpdate: null });
    } else {
      this.setState({ updatingError: true });
    }
  };

  cancel() {
    this.setState({ newValue: "", duplicateError: false, addingError: false });
  }

  async save() {
    if (!this.state.newValue) return;

    this.clearErrorMessages();

    if (
      this.props.values
        .map(v => v.value.toLowerCase())
        .indexOf(this.state.newValue.toLowerCase()) > -1
    ) {
      this.setState({
        duplicateError: true,
        addingError: false,
        deletingError: false,
        errorMessage: ""
      });
      return;
    }
    await this.props.add(this.state.newValue);
    if (this.props.adding.success) {
      this.setState({ newValue: "" });
    } else {
      this.setState({
        addingError: true,
        duplicateError: false,
        deletingError: false,
        errorMessage: ""
      });
    }
  }

  async remove(id) {
    this.clearErrorMessages();

    await this.props.delete(id);

    if (this.props.deleting[id] && !this.props.deleting[id].success) {
      if (this.props.deleting[id] && this.props.deleting[id].message)
        this.setState({
          errorMessage: this.props.deleting[id].message
        });
      else
        this.setState({
          deletingError: true
        });
    }
  }

  render() {
    return (
      <div>
        <label className="input-label">{this.props.title}</label>
        <div className="chip-container">
          {this.props.values
            .sort((a, b) =>
              this.props.sort
                ? a.value.toLowerCase().localeCompare(b.value.toLowerCase())
                : 0
            )
            .map((tag, index) => {
              return (
                <div
                  className="chip"
                  key={index}
                  onDoubleClick={() => this.onUpdateTagClick(tag)}
                >
                  {this.state.tagForUpdate &&
                  this.state.tagForUpdate.key === tag.key ? (
                    <div>
                      <input
                        onBlur={() => this.setState({ tagForUpdate: null })}
                        onChange={event => {
                          this.setState({
                            tagForUpdate: {
                              ...this.state.tagForUpdate,
                              value: event.target.value
                            }
                          });
                        }}
                        onKeyDown={event => {
                          if (event.key === "Enter") {
                            this.updateTag();
                          }
                        }}
                        ref={el => (this.editTagInput = el)}
                        value={this.state.tagForUpdate.value}
                      />
                      {this.props.updating.loading && (
                        <LoadingSpinner loading={true} />
                      )}
                    </div>
                  ) : (
                    <div>
                      <span>{tag.value}</span>
                      {this.props.deleting[tag.key] &&
                      this.props.deleting[tag.key].loading ? (
                        <LoadingSpinner
                          loading={
                            this.props.deleting[tag.key] &&
                            this.props.deleting[tag.key].success
                          }
                        />
                      ) : (
                        <i
                          className="material-icons delete-chip"
                          onClick={this.remove.bind(this, tag.key)}
                        >
                          close
                        </i>
                      )}
                    </div>
                  )}
                </div>
              );
            })}

          {this.state.tagForUpdate ? (
            this.state.tagForUpdate.value !==
              (
                this.props.values.find(
                  t => t.key === this.state.tagForUpdate.key
                ) || {}
              ).value &&
            !this.props.updating.loading && (
              <span className="xs-text accent-text">
                Press enter to save changes
              </span>
            )
          ) : (
            <input
              type="text"
              placeholder="Add New"
              value={this.state.newValue}
              name="newValue"
              onChange={this.onChange.bind(this)}
              onKeyDown={e => {
                if (e.key === "Enter") this.save();
              }}
            />
          )}
          {this.props.adding.loading ? (
            <LoadingSpinner loading={this.props.adding.loading} />
          ) : (
            <div className="tag-actions">
              {this.state.newValue && <p onClick={this.save.bind(this)}>Add</p>}
              {this.state.newValue && (
                <p className="accent-text" onClick={this.cancel.bind(this)}>
                  Cancel
                </p>
              )}
            </div>
          )}
        </div>
        <FadeoutErrorMessage
          show={this.state.duplicateError}
          message={`Could not add duplicate ${this.props.name}`}
          timeOut={3000}
        />
        <FadeoutErrorMessage
          show={this.state.addingError}
          message={`Could not add ${this.props.name}`}
          timeOut={3000}
        />
        <FadeoutErrorMessage
          show={this.state.deletingError}
          timeOut={3000}
          message={`Could not delete ${this.props.name}`}
        />
        <FadeoutErrorMessage
          show={this.state.updatingError}
          message={`Could not update ${this.props.name}`}
          timeOut={3000}
        />
        <FadeoutErrorMessage
          show={this.state.errorMessage}
          timeOut={3000}
          message={this.state.errorMessage}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/TagInput.jsx